import { useTranslation } from 'react-i18next';
import { Granularity, GranularityFrequencyLabels } from '../../../constants/granularity';

export const useFilterOptions = (granularities: Granularity[]) => {
  const { t } = useTranslation();

  return granularities.map(value => ({ value, label: t(GranularityFrequencyLabels[value]) }));
};
